// extracted by mini-css-extract-plugin
export default {"formBox":"afsqx1IjXcYYUI2dRoFf","btnRow":"NtS9LabUoQN6FhS0AlDO"};